module.exports = __webpack_public_path__ + "img/buissonniere-e-commerce-success-story-img-1.d8d23a13.jpg";